// extracted by mini-css-extract-plugin
export default {"container":"ErrorPage_container__91s4E","homeLink":"ErrorPage_homeLink__sAPgp"};